import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';

import Form, { ButtonItem, GroupItem, IButtonItemProps, Label, RequiredRule, SimpleItem } from 'devextreme-react/form';
import ValidationGroup from 'devextreme-react/validation-group';

import { useAuth } from 'context/auth';

import { useLazyGetContractorDetailInfoQuery } from 'bus/contractor/services/services';
import {
  useChangeContractorLegalMutation,
  useLazyGetContractorLegalSearchQuery,
} from 'bus/contractorLegal/services/services';
import { ContractorLegalItem } from 'bus/contractorLegal/types';
import { useGetContractorObjectLocationsQuery } from 'bus/contractorObject/services';

import { typeContractor } from 'types/books';

import { initialStateForm } from '../../Views/ContractorLegalList/utils';

const IndividualForm: FC = () => {
  let { id } = useParams<{ id: string }>();
  const { getClaims }: any = useAuth();
  const [changeContractorLegal] = useChangeContractorLegalMutation();

  let createCatalogGroupRef = useRef<any>(null);
  const [isOwnerCheckBox, setIsOwnerCheckbox] = useState(false);

  const [getContractorDetailInfo] = useLazyGetContractorDetailInfoQuery();
  const [getContractorLegalSearch] = useLazyGetContractorLegalSearchQuery();
  const { data: contractorObjectLocations } = useGetContractorObjectLocationsQuery();

  const [form, setForm] = useState<ContractorLegalItem>({ ...initialStateForm });

  const getData = useCallback(async () => {
    const data = await getContractorDetailInfo({ id }).unwrap();
    setForm((prev) => ({ ...prev, ...data }));
  }, [getContractorDetailInfo, id]);

  useEffect(() => {
    getData();
  }, [getData]);

  //заполнение формы
  /* useEffect(() => {
    setForm((prev) => ({ ...prev, ...data }));
  }, [data]); */

  //Поиск по инн
  /* useEffect(() => {
    if (storeContractorLegal.contractorLegalListSearch.data?.name) {
      setForm((prev) => ({ ...prev, ...storeContractorLegal.contractorLegalListSearch.data }));
      //@ts-ignore
      setIsOwnerCheckbox(storeContractorLegal.contractorLegalListSearch.data?.isOwner);
    }
    return () => {};
  }, [storeContractorLegal.contractorLegalListSearch.data, dispatch]); */

  const handleSubmit = (e: any) => {
    e.preventDefault && e.preventDefault();
    if (createCatalogGroupRef.current.instance.validate().isValid) {
      changeContractorLegal(form);
      toast.success('Успешно сохранено', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const searchByInn = async () => {
    const response = await getContractorLegalSearch({ inn: form.inn }).unwrap();
    setForm((prev) => ({ ...prev, ...response }));
  };

  const passwordButton = {
    name: 'test',
    options: {
      onClick: searchByInn,
      icon: 'search',
      type: 'default',
      stylingMode: 'text',
    },
  };

  const isCanEditLegalContractor = !getClaims(['CanEditLegalContractor']);

  const buttonOptions: IButtonItemProps['buttonOptions'] = {
    text: 'Сохранить',
    type: 'success',
    useSubmitBehavior: true,
    disabled: isCanEditLegalContractor,
  };

  return (
    <div className="pa-2">
      <form onSubmit={handleSubmit}>
        <ValidationGroup>
          <Form formData={form} ref={createCatalogGroupRef} readOnly={isCanEditLegalContractor}>
            <GroupItem cssClass="first-group" colCount={12}>
              <SimpleItem
                dataField="inn"
                colSpan={6}
                editorOptions={{
                  buttons: [passwordButton],
                }}
              >
                <Label text="ИНН" />
                <RequiredRule message="Заполните поле ИНН" />
              </SimpleItem>

              <SimpleItem
                dataField="contractorType"
                colSpan={6}
                editorType="dxSelectBox"
                editorOptions={{
                  items: typeContractor,
                  displayExpr: 'name',
                  valueExpr: 'id',
                }}
              >
                <Label text="Тип" />
                <RequiredRule message="Заполните поле Тип" />
              </SimpleItem>

              <SimpleItem dataField="fullName" colSpan={12}>
                <Label text="Полное наименование" />
                <RequiredRule message="Заполните поле Полное наименование" />
              </SimpleItem>

              <SimpleItem dataField="name" colSpan={12}>
                <Label text="Краткое наименование" />
                <RequiredRule message="Заполните поле Краткое наименование" />
              </SimpleItem>

              <SimpleItem dataField="directorSurname" colSpan={4}>
                <Label text="Фамилия" />
              </SimpleItem>
              <SimpleItem dataField="directorName" colSpan={4}>
                <Label text="Имя" />
              </SimpleItem>

              <SimpleItem dataField="directorMiddleName" colSpan={4}>
                <Label text="Отчество" />
              </SimpleItem>

              <SimpleItem dataField="address" colSpan={12}>
                <Label text="Адрес" />
              </SimpleItem>

              <SimpleItem dataField="ogrn" colSpan={6}>
                <Label text="ОГРН" />
                <RequiredRule message="Заполните поле ОГРН" />
              </SimpleItem>

              <SimpleItem dataField="kpp" colSpan={6}>
                <Label text="КПП" />
              </SimpleItem>

              <SimpleItem dataField="phone" colSpan={6} editorOptions={{ mask: '+7 (000) 000-00-00' }}>
                <Label text="Телефон" />
              </SimpleItem>

              <SimpleItem dataField="email" colSpan={6}>
                <Label text="Email" />
              </SimpleItem>

              <SimpleItem dataField="declarationUrl" colSpan={6} visible={isOwnerCheckBox}>
                <Label text="Ссылка на единый реестр сертификатов соответствия и деклараций о соответствии" />
                {/* <RequiredRule message="Заполните поле ссылка" /> */}
              </SimpleItem>

              <SimpleItem
                dataField="locationType"
                colSpan={6}
                editorType="dxSelectBox"
                editorOptions={{
                  items: contractorObjectLocations,
                  displayExpr: 'name',
                  valueExpr: 'id',
                }}
              >
                <Label text="Местность" />
                <RequiredRule message="Заполните поле Местность" />
              </SimpleItem>

              <SimpleItem
                dataField="declarationName"
                colSpan={6}
                visible={isOwnerCheckBox}
                editorOptions={{ maxLength: 200 }}
              >
                <Label text="Наименование декларации о соответствии" />
              </SimpleItem>

              <SimpleItem dataField="comment" colSpan={6} editorType="dxTextArea">
                <Label text="Комментарий" />
              </SimpleItem>
            </GroupItem>

            <GroupItem colCount={4}>
              <SimpleItem
                dataField="isOwner"
                colSpan={6}
                editorType="dxCheckBox"
                editorOptions={{
                  text: 'Собственная организация',
                  onValueChanged: (e) => setIsOwnerCheckbox(e.value),
                }}
              >
                <Label text=" " />
              </SimpleItem>

              <SimpleItem
                dataField="isProvider"
                colSpan={6}
                editorType="dxCheckBox"
                editorOptions={{ text: 'Поставщик' }}
              >
                <Label text=" " />
              </SimpleItem>
            </GroupItem>

            <ButtonItem horizontalAlignment="left" buttonOptions={buttonOptions} />
          </Form>
        </ValidationGroup>
      </form>
    </div>
  );
};

export default IndividualForm;
